// Copyright (c) 2016 Deere & Company

import Modal, {getDefaultState as getModalDefaultState} from '../../shared/state/modal';

const ProductDetailsStatusChangeModal = Modal;

export const getDefaultState = () => getModalDefaultState();

export default ProductDetailsStatusChangeModal;



// WEBPACK FOOTER //
// ./src/product/details/state/product-details-status-change-modal.js